module.exports = __webpack_public_path__ + "d736dd17.svg";